module.exports = __webpack_public_path__ + "img/p5.d9c6b6c3.png";